module.exports = __webpack_public_path__ + "9c16a3a90f60787521094c777c78eada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maya_pink_logo.png
// module id = 953
// module chunks = 0